import React, { useState } from "react";
import Page from "../components/Page";
import { useSubmitForm } from "../hooks/useSubmitForm";
import { useSelector } from "react-redux";
import LoginPage from "./LoginPage";

function AbsencePage() {
	const { handleSubmit } = useSubmitForm();
	const [date, setDate] = useState("");
	const { user } = useSelector((state) => state.auth);

	// Redirect to login page if there isn't a user logged in
	if (!user) {
		return <LoginPage />;
	}

	return (
		<Page
			data-wf-page="635c128e44ade40c56e6173d"
			data-wf-site="634efd6b20b65bfc05be44e4"
		>
			<div className="section wf-section">
				<div className="containercentered w-container">
					<h2>Request Absence</h2>
					<div className="authformblock fillgainsboro w-form">
						<form
							onSubmit={(e) => {
								e.preventDefault();
								handleSubmit(e);
							}}
							id="wf-form-dates-selection"
							name="wf-form-dates-selection"
							data-name="Absence"
							method="get"
							className="formcontact"
						>
							{/*Name*/}
							<div>
								<label htmlFor="name">Full Name</label>
								<input
									type="text"
									className="absencefield w-input"
									maxLength={256}
									name="Name"
									data-name="Name"
									placeholder="Your Name"
									id="name"
									required
								/>
							</div>

							{/* Cadet */}
							<div>
								<label htmlFor="rank">Cadet Rank</label>
								<input
									type="text"
									className="absencefield w-input"
									maxLength={256}
									name="Cadet Rank"
									data-name="rank"
									placeholder="Your Rank"
									id="rank"
									required
								/>
							</div>

							{/* Date */}
							<div>
								<label htmlFor="date">Date of Absence</label>
								<input
									type="date"
									value={date}
									onChange={(e) => setDate(e.target.value)}
									className="absencefield w-input"
									name="Date"
									data-name="date"
									id="date"
									required
								/>
							</div>

							{/* Reason */}
							<div>
								<label htmlFor="reason">Reason for Absence</label>
								<textarea
									placeholder="Please provide details about your absence"
									maxLength={5000}
									id="reason"
									name="Reason"
									required
									data-name="reason"
									className="absencefield min128 w-input"
								/>
							</div>

							<input
								type="submit"
								value="Submit"
								className="buttonsubmit w-button"
							/>
						</form>
					</div>
				</div>
			</div>
		</Page>
	);
}

export default AbsencePage;
